import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { TWhiteLabelUserDataState } from '../types';

const initialState: TWhiteLabelUserDataState = {
  token: null,
};

export const whiteLabelUserDataSlice = createSlice({
  name: 'whiteLabelUserData',
  initialState,
  reducers: {
    setWhiteLabelUserDataToken: (_, { payload }: PayloadAction<string | null>) => {
      return {
        token: payload,
      };
    },
  },
});

export const { setWhiteLabelUserDataToken } = whiteLabelUserDataSlice.actions;
